/**
 * Series scripts
 *
 * @copyright 2018 Linguistica 360
 */

import 'slick-carousel';

import $ from 'jquery';
import $clamp from 'clamp-js';
import lozad from 'lozad';
import throttle from 'lodash/throttle.js';

import { Script, injector } from '../shared/injector.js';
import { $wrap, resolveRoot } from '../shared/utils.js';


const observer = lozad();
observer.observe();


function initLine(inits, callback) {
    return function () {
        const $prev = $(this).prev().find('.netflix-arrow.left');
        const $next = $(this).prev().find('.netflix-arrow.right');

        const $slick = $(this);

        const cbFunction = function () {
            if (!(--inits)) {
                $('.netflix-loading').hide();
                $('.netflix-loading-content').css('visibility', 'visible');
                callback();
            }
        };

        $slick.on('init', function (_, slick) {
            $slick.css('width', 'auto');

            const $active = slick.$slides.filter('.active');
            if ($active.length) {
                $slick.on('afterChange', function () {
                    cbFunction();
                });
                slick.goTo($active.data('slick-index') - 1, true);
            } else {
                cbFunction();
            }
        });

        $slick.slick({
            rows: 0,
            infinite: false,
            dots: false,
            speed: 300,
            arrows: false,
            variableWidth: true,
            slidesToScroll: 1,
            swipeToSlide: true,
        });

        if ($slick.data('ajax') && $slick.data('count') > 0) {
            const count = $slick.data('count');
            $slick.on('setPosition', throttle(() => {
                if ($slick.data('ajax-loading')) return;

                const last = $slick.find('.netflix-item-wrapper').length - 1;
                if (last === count - 1) return;

                let index = 0, show = 10;
                const $current = $slick.find('.slick-slide.slick-current');
                if ($current.length) {
                    index = $current.data('slick-index');

                    const $line = $slick.parents('.netflix-line-wrapper');
                    show = Math.ceil($line.width() / $current.width());
                }

                const nextShow = Math.max(show * 4, 24);
                const next = Math.floor(index + nextShow);
                const load = Math.min(count, next) - 1;
                if (index + show * 2 > last) {
                    $slick.data('ajax-loading', true);
                    $slick.parent().find('.loading').show();

                    const offset = last + 1;
                    const limit = load - last;

                    $.get(resolveRoot($slick.data('ajax')), {
                        offset, limit,
                    }).then((html) => {
                        const $html = $('<div>' + html + '</div>');
                        const sel = '.netflix-item-wrapper';
                        $html.find(sel).each((_, wrap) => {
                            $slick.slick('slickAdd', $(wrap));
                        });

                        observer.observe();
                    }).fail(() => {
                        console.log('stripe items could not be loaded');
                    }).always(() => {
                        $slick.removeData('ajax-loading');
                        $slick.parent().find('.loading').hide();
                    });
                }
            }, 100));
        }

        const $wrapper = $slick.parents('.netflix-line-wrapper');
        const $button = $wrapper.find('.netflix-line-toolbar a');
        $button.on('click', () => {
            $slick.slick('slickGoTo', 0);
        });

        $prev.on('click', () => {
            let index = 0, show = 10;
            const $current = $slick.find('.slick-slide.slick-current');
            if ($current.length) {
                index = $current.data('slick-index');

                const $line = $slick.parents('.netflix-line-wrapper');
                show = Math.floor($line.width() / $current.width());
            }

            const prev = Math.max(index - show, 0);
            $slick.slick('goTo', prev);
        });

        $next.on('click', () => {
            const count = $slick.data('count');

            let index = 0, show = 10;
            const $current = $slick.find('.slick-slide.slick-current');
            if ($current.length) {
                index = $current.data('slick-index');

                const $line = $slick.parents('.netflix-line-wrapper');
                show = Math.floor($line.width() / $current.width());
            }

            const next = Math.min(index + show, count - 1);
            $slick.slick('goTo', next);

            observer.observe();
        });
    };
}

let loading = false;
let lazyInterval = null;
function loadLazyStripe($strip) {
    loading = true;
    const published = $strip.data('published');
    const id = $strip.data('id');
    const hide = $strip.css('display') === 'none';
    $strip.append('<div class="loading"></div>');
    $.get(resolveRoot(`series/ajax/stripe/${published}/${id}`)).done((res) => {
        loading = false;
        const $res = $(res);
        if (hide) $res.css('display', 'none');
        $strip.replaceWith($res);
        initLine(0, () => {}).call($res.find('.netflix-line'));
        observer.observe();
    }).fail((res) => {
        loading = false;
        $strip.empty();
        console.error(res);
    });
}

function initLazyStripes() {
    if (loading) return;
    const $window = $(window);
    const off = $window.height() / 10;
    const bottom = $window.scrollTop() + $window.height() + off;

    $('.netflix-line-row.unloaded').each(function () {
        const $this = $(this);
        if ($this.css('display') === 'none') return;
        const thisBottom = $this.offset().top + $this.height();
        if (thisBottom < bottom) {
            loadLazyStripe($this);
            return false;
        }
    });

    if (!$('.netflix-line-row.unloaded').length) {
        clearInterval(lazyInterval);
    }
}

injector.injectClass(class extends Script {
    onResize() {
        observer.observe();
    }

    onLoad() {
        this.initSeries();
        this.initClamp();
        this.initFilters();
    }

    initFilters() {
        const $slick = $('.landing-filters');

        $slick.slick({
            arrows: false,
            variableWidth: true,
            infinite: false,
        });


        const $prevArrow = $('.navicons-arrows.landing .left');
        const $nextArrow = $('.navicons-arrows.landing .right');

        $prevArrow.on('click', () => { $slick.slick('slickPrev'); });
        $nextArrow.on('click', () => { $slick.slick('slickNext'); });
    }

    initSeries() {
        let inits = $('.netflix-line').length;

        $('.netflix-line').each(initLine(inits, function () {
            if (!$('.netflix-line-row.unloaded').length) return;
            lazyInterval = setInterval(() => initLazyStripes(), 250);
        }));

        $('.rightbar-item').on('click', function () {
            const url = $(this).data('url');
            location.href = resolveRoot(url);
        });

        const filterName = $('.netflix-filter').data('name');
        const $filter = $('.netflix-filter');

        $filter.on('click', 'li', $wrap(($this) => {
            const tag = $this.data('value');

            if (tag === '') {
                $('.netflix-line-row').show();
                $filter.find('.netflix-filter-value').html('');
            } else {
                $('.netflix-line-row').hide();
                $(`.netflix-line-row[data-tag-${tag}]`).show();
                $filter.find('.netflix-filter-value').html(`: ${$this.html()}`);
            }

            $filter.find(':checkbox').prop('checked', false);

            sessionStorage.setItem(`landing-filter-${filterName}`, tag);
        }, true));

        const tag = sessionStorage.getItem(`landing-filter-${filterName}`);
        if (tag) {
            $filter.find(`li[data-value=${tag}]`).trigger('click');
        }
    }

    initClamp() {
        const selector = '.netflix-item-wrapper.news-clamp .thumbnail-desc p';
        $(selector).each(function () {
            $clamp(this, { clamp: 4 });
            $(this).css('line-height', '1.1em'); // android fix
        });
    }
});
